import { APIClient } from "./api_helper";
import * as url from "./url_helper";
import { GET_STORES } from "./url_helper";

const api = new APIClient();
// Gets the logged in user data from local session

export const getStoresApi = (params = { keyword_search: "" }) =>
  api.create(url.GET_STORES, { params: { keyword_search: params } });

export const addStore = (store) =>
  api.create(url.CREATE_STORE, { params: store });

// get detail store by store id
export const getStoreDetail = (storeID) =>
  api.create(url.GET_STORE_DETAIL, { params: { store_id: storeID } });

//update Store
export const updateStore = (store) =>
  api.create(url.UPDATE_STORE, { params: store });

export const deleteStore = (store) =>
  api.create(url.DELETE_PRODUCTS, { params: { store_ids: [store.store_id] } });
